module.exports = __webpack_public_path__ + "img/pause-circle-regular.58d66bba.svg";